module.exports = __webpack_public_path__ + "static/img/sevenLast.995e8f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sevenLast.png
// module id = 974W
// module chunks = 1